<template>
    <div class="execution-steps">
        <ul class="execution-steps__list">
            <li class="execution-steps__item"
                v-for="(step, idx) in steps"
                :key="step.title">
                <CurrentOffer
                    :title="step.title"
                    :description="step.description"
                    :link="step.link"
                    />
            </li>
        </ul>
    </div>
</template>

<script>
import CurrentOffer from '@/components/ui/CurrentOffer';
export default {
    name: 'CurrentOffers',
    components: {
        CurrentOffer
    },
    data() {
        return {
            steps: [
                {
                    title: 'Рассчитаем стоимость через MAX',
                    description: 'Предоставьте документы менеджеру в Max и получите резульаты расчета стоимости полиса ипотечного страхования и ссылку на оплату!',
                    link: {
                        text: 'Перейти в MAX',
                        url: 'https://max.ru/u/f9LHodD0cOK1n3FASmw4ZzQMjgSw94SPRXmsKrzUso44autKlvH3WzPY_pc' 
                    }
                },
                {
                    title: 'Страхование спортсменов онлайн от 45р',
                    description: 'Получите деньги на лечение, если с вами произойдет что-то нежелательное.',
                    link: {
                        text: 'Оформить полис',
                        url: '/widget/ns-sport/'
                    }
                },
                {
                    title: 'Страхование для путешественников зарубеж',
                    description: 'Полис путешественника позволит получить визу и возместить расходы на лечение за границей.',
                    link: {
                        text: 'Оформить полис',
                        url: '/calculators/vzr/'
                    }
                }
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.execution-steps {
    &__list {
        display: flex;
        justify-content: space-between;

        @media #{$screen-medium} {
            flex-direction: column;
        }
    }

    &__item {
        @include flex-width-three-in-row($gap-normal);

        @media #{$screen-medium} {
            @include resetting-vertical-indentation-of-first;

            width: 100%;

            margin-top: rem($gap-normal);
        }
    }

    &__comment {
        @include text-normal($font-weight-regular, $line-height-normal);

        margin-top: rem($gap-big);

        color: $primary;

        opacity: .5;

        @media #{$screen-medium} {
            font-size: rem($font-size-small);
        }
    }
}
</style>